import yup from '@/utils/yup-global'

export const contactSchema = yup.object().shape({
  firstname: yup.string().required('Tên không được để trống'),
  lastname: yup.string().required('Họ không được để trống'),
  phone_number: yup
    .string()
    .phoneNumber('Số điện thoại không hợp lệ')
    .required('Số điện thoại không được để trống'),
  email: yup.string().email('Email không hợp lệ').required('Email không được để trống'),
  title: yup.string().required('Tiêu đề không được để trống'),
  description: yup.string().required('Mô tả không được để trống'),
})
